"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHelpers = void 0;
class ChatHelpers {
    static buildSelectedModel(avatar) {
        var _a;
        if (!(avatar === null || avatar === void 0 ? void 0 : avatar.model)) {
            return null;
        }
        return {
            model: avatar.model.model,
            provider: avatar.model.provider,
            avatar: (_a = avatar.id) === null || _a === void 0 ? void 0 : _a.toString(),
        };
    }
    static buildStartPrompt(currentSectionIndex, selectedSection) {
        if (currentSectionIndex > 0) {
            return 'tutorial.start.prompt.continued'.t({ sectionName: selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.title });
        }
        return 'tutorial.start.prompt'.t();
    }
    static async getFileSectionContent(sectionId) {
        var _a;
        if (this.tutorial.source === 'ai') {
            return;
        }
        const response = await this.apiService.back.get('tutorial.section.content', { routeParams: { id: String((_a = this.selectedSection) === null || _a === void 0 ? void 0 : _a.sectionId) } });
        if (response && response.success && response.data) {
            return this.chatComponent.addSimulatedAIMessage(response.data.content);
        }
    }
}
exports.ChatHelpers = ChatHelpers;
